


















import { Component, Vue, Watch } from 'vue-property-decorator';
import OpenSeadragon from 'openseadragon';
import { annotationModule, authModule, viewerModule } from '@/store';
import Annotorious from '@recogito/annotorious-openseadragon';
import { AnnotoriousClass } from '@recogito/annotorious-openseadragon';
import { ISelection } from '@recogito/annotorious';
import { requireLogin } from '@/utils/utils';

@Component
export default class ImageView extends Vue {
  viewer!: OpenSeadragon.Viewer;
  anno!: AnnotoriousClass;
  mode = 0;

  get seg() {
    return annotationModule.seg;
  }

  get selection() {
    return viewerModule.selection;
  }

  get annotorious() {
    return viewerModule.annotorious;
  }

  get selected() {
    return viewerModule.selectedAnnotorious;
  }

  get routeName() {
    return this.$route.name;
  }

  get segStatus() {
    return annotationModule.segStatus;
  }

  get currentUser() {
    return authModule.currentUser;
  }

  get disabled() {
    return (
      !this.currentUser ||
      (this.routeName === 'People' &&
        this.segStatus &&
        this.segStatus.personAnnotationCompleted) ||
      (this.routeName === 'Transcription' &&
        this.segStatus &&
        this.segStatus.transcriptionCompleted)
    );
  }

  @Watch('annotorious', { deep: true, immediate: false })
  drawAnnotations() {
    if (this.anno) {
      this.anno.clearAnnotations();
      this.annotorious.forEach((anno) => {
        this.anno.addAnnotation(anno);
      });
    }
  }

  @Watch('$route', { deep: true })
  clearAnnotation() {
    if (this.anno) {
      viewerModule.SET_ANNOTORIOUS({ annotorious: [] });
      this.anno.clearAnnotations();
    }
  }

  @Watch('selection', { deep: true })
  clearSelection() {
    if (!this.selection) {
      this.anno.cancelSelected();
    }
  }

  @Watch('selected', { deep: true })
  highlightAnnotorious() {
    if (this.anno && this.selected) {
      this.anno.cancelSelected();
      this.anno.selectAnnotation(this.selected);
      this.anno.panTo(this.selected);
    }
  }

  @Watch('mode')
  toggleDrawingEnable() {
    requireLogin();
    this.anno.setDrawingEnabled(this.mode == 1);
  }

  @Watch('seg.id')
  setupViewer() {
    if (!this.seg || this.seg.uri === '') return;
    if (this.viewer) this.viewer.destroy();
    this.viewer = OpenSeadragon({
      id: 'osd-viewer',
      sequenceMode: true,
      showNavigationControl: true,
      showNavigator: false,
      showSequenceControl: false,
      showRotationControl: true,
      prefixUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/openseadragon/2.4.0/images/',
      tileSources: { type: 'image', url: this.seg.uri }
    });
    this.anno = Annotorious(this.viewer, {
      disableEditor: true
    });
    this.anno.on('createSelection', (anno) => {
      viewerModule.SET_SELECTION({ selection: anno as ISelection });
      this.mode = 0;
    });
    this.drawAnnotations();
  }

  mounted() {
    this.setupViewer();
    this.clearAnnotation();
  }

  destroyed() {
    this.viewer.destroy();
  }
}
